//
export default [
    {
        text        : 'NUMERO',
        value       : 'id',
    },
    {
        text        : 'TIPO',
        value       : 'type',
    },
    {
        text        : 'FECHA',
        value       : 'created_parent_at',
        //format      : 'datetime'
    },
    {
        text        : 'TOTAL',
        format      : 'currency',
        value       : ({ pivot }) => pivot ? pivot.amount : 0,
    },
]